<h3>I want to detect questions about...</h3>

<div class="intent__field-container">
  <mat-form-field fxFlex>
    <input
      [(ngModel)]="nameInput"
      matInput
      maxlength="64"
      placeholder="trains, transportation, wifi, check-in times, check-out times, kitchen, discount, restaurants..." />
  </mat-form-field>
</div>

<div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="end center">
  <button [disabled]="loading" mat-flat-button (click)="okClicked()">
    Create
    <mat-spinner *ngIf="loading" class="button__spinner" diameter="30"></mat-spinner>
  </button>
</div>
